import React from "react";
import Navbar from "../../components/navigation/Navbar";
import Footer from "../../components/footer/Footer";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import contactBanner from "../../assets/images/contact-banner.jpg";
import { Link } from "react-router-dom";
import NorthEastOutlinedIcon from "@mui/icons-material/NorthEastOutlined";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import MarkEmailUnreadOutlined from "@mui/icons-material/MarkEmailUnreadOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import ConnectWithoutContactOutlinedIcon from "@mui/icons-material/ConnectWithoutContactOutlined";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const Contact = () => {
  return (
    <div>
      <Navbar />
      <div
        className="page-header bg-[#F8F8F8]  page-contact-header"
        style={{ backgroundImage: `url(${contactBanner})` }}
      >
        <div className="container">
          <h1 className="font-bold text-2xl mb-3 text-[#fff]">
            Reach out to us
          </h1>
          <ul className="flex gap-2">
            <Link to="/" className="text-sm text-[#fff]">
              Home
            </Link>
            <ChevronRightIcon sx={{ fontSize: "19px", color: "#fff" }} />
            <Link to="/contact-us" className="text-sm text-[#fff]">
              Contact Us
            </Link>
          </ul>
        </div>
      </div>

      <section className="pt-[4rem] pb-[4rem]">
        <div className="container">
          <div className="">
            <div className="small-text">
              <span></span> Offices
            </div>
            <h1 className="heading1">Our Offices</h1>
          </div>

          <div className="flex office-add">
            <div className="officeBox">
              <h3>Dubai Office</h3>
              <div className="as-wrap">
                <div className="as-left">
                  <h6>Address</h6>
                  <p>
                    P.O. Box: 214313 03 13th Floor, Al Saqr business Tower
                    Sheikh Zayed road Dubai UAE
                  </p>
                </div>

                <div className="as-right">
                  <h6>Working Hours</h6>
                  <p>Sat - Thu 8:00am to 6:00pm</p>
                  <p>Sunday - Closed</p>
                </div>
              </div>

              <a
                href="https://maps.app.goo.gl/oeptf6UaqC4Q1C6z7"
                target="_blank"
                rel="noopener noreferrer"
              >
                Show on a map{" "}
                <NorthEastOutlinedIcon
                  sx={{ fontSize: "17px", marginLeft: "8px" }}
                />
              </a>
            </div>

            <div className="officeBox">
              <h3>Sharjah Office</h3>
              <div className="as-wrap">
                <div className="as-left">
                  <h6>Address</h6>
                  <p>
                    P.O. Box: 37700 Industrial Area 13, Opposite Adnoc near Bin
                    Ladin Signal Al Aziz Building Sharjah UAE
                  </p>
                </div>

                <div className="as-right">
                  <h6>Working Hours</h6>
                  <p>Sat - Thu 8:00am to 6:00pm</p>
                  <p>Sunday - Closed</p>
                </div>
              </div>

              <a
                href="https://www.google.com/maps/place/AGA+Amin+Grand+Asia/@25.3067976,55.4324403,17z/data=!4m6!3m5!1s0x3e5f5f17438261a1:0xe39a512e38299a38!8m2!3d25.3066866!4d55.4326197!16s%2Fg%2F11v4j88nc_?entry=ttu&g_ep=EgoyMDI0MTAxNi4wIKXMDSoASAFQAw%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
              >
                Show on a map
                <NorthEastOutlinedIcon
                  sx={{ fontSize: "17px", marginLeft: "8px" }}
                />
              </a>
            </div>
          </div>

          <div className="mt-[5rem]">
            <h1 className="heading1">Reach out to us</h1>

            <div className="bg-[#F6F8FA] office-lg-box rounded-3xl mt-5">
              <div className="as-wrap">
                <div className="as-left">
                  <div>
                    <h3>
                      <HomeOutlinedIcon
                        sx={{
                          color: "#6e768c",
                          fontSize: "20px",
                          marginRight: "10px",
                        }}
                      />
                      Head Office Address
                    </h3>
                    <h1>
                      P.O. Box: 214313 03 13th Floor, Al Saqr business Tower
                      Sheikh Zayed road Dubai UAE
                    </h1>
                  </div>

                  <div>
                    <h3>
                      <ChatOutlinedIcon
                        sx={{
                          color: "#6e768c",
                          fontSize: "20px",
                          marginRight: "10px",
                        }}
                      />
                      Call us
                    </h3>
                    <h1>
                      <a href="tel:+971501501145">+(971) 50 138 1984</a>
                      <br />
                      <a href="tel:+971501501145">+(971) 50 150 1145</a>
                      <br />
                      <a href="tel:+97143236878">+(971) 4 323 6878</a>
                      <br />
                    </h1>
                  </div>

                  <div>
                    <h3>
                      <MarkEmailUnreadOutlined
                        sx={{
                          color: "#6e768c",
                          fontSize: "20px",
                          marginRight: "10px",
                        }}
                      />
                      Email Us
                    </h3>
                    <h1>
                      <a href="tel:+971501501145">info@agacrane.com</a>
                    </h1>
                  </div>
                </div>

                <div className="as-right">
                  <div>
                    <h3>
                      <AccessTimeOutlinedIcon
                        sx={{
                          color: "#6e768c",
                          fontSize: "20px",
                          marginRight: "10px",
                        }}
                      />
                      Office Hours
                    </h3>
                    <h1>Sat to Thu 8:00am to 6:00pm</h1>
                    <h1>Sunday - Closed</h1>
                  </div>

                  <div>
                    <h3>
                      <ConnectWithoutContactOutlinedIcon
                        sx={{
                          color: "#6e768c",
                          fontSize: "20px",
                          marginRight: "10px",
                        }}
                      />
                      Connect with us
                    </h3>

                    <div className="flex gap-2">
                      <a
                        href="https://wa.me/971501501145"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <WhatsAppIcon
                          sx={{ fontSize: "25px", color: "#0DC143" }}
                        />
                      </a>
                      <a href="#" target="_blank" rel="noopener noreferrer">
                        <FacebookIcon
                          sx={{ fontSize: "25px", color: "#1773EA" }}
                        />
                      </a>
                      <a
                        href="https://www.instagram.com/craneagacompany/profilecard/?igsh=MTE3NnYxMjkyaTNtOQ=="
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <InstagramIcon
                          sx={{ fontSize: "25px", color: "#A632A8" }}
                        />
                      </a>
                      <a
                        href="https://www.linkedin.com/in/crane-mousavi-91a2ba137?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <LinkedInIcon
                          sx={{ fontSize: "25px", color: "#0273AF" }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="map-google">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3606.9228027799754!2d55.4324403!3d25.3067976!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5f17438261a1%3A0xe39a512e38299a38!2sAGA%20Amin%20Grand%20Asia!5e0!3m2!1sen!2s!4v1729578623265!5m2!1sen!2s"
          width="100%"
          height="550"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Map"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <Footer />
    </div>
  );
};

export default Contact;
